module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-a5e44f62bba0713862fec27f67dc3a23.jpg";